import React from "react";

import "./styles.scss"
import ESGChatMain from "../../esg-chat/esg-chat";
import uris from "../../../config/uris";


const GeminiPromptEvaluation = () => {
    const menuData = {
    title: 'Prompt Evaluation',
    parentMenu: {
        name: 'Gemini',
        link: uris?.entityList,
    },
    subMenu: {
        name: 'Prompt Evaluation',
        link: uris?.geminiPromptEvaluation,
    },
}
    return (
        <div className="prompt-evaluation-main">
            <ESGChatMain 
            breadcrumbs={menuData}
            searchType="Company"
            showDisclosuresSection
            promptEvaluation={true}
            promptMode="private"
            />
        </div>
    )
}

export default GeminiPromptEvaluation;